import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { TabIndexPipe } from '../../pipes/tabindex.pipe';

@Component({
  selector: 'oir-accordion',
  templateUrl: './accordion.component.html',
  styleUrls: ['./accordion.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccordionComponent {
  private _ariaAccordionDescription: string;
  @Input() canToggle = true;
  @Input('defaultClosed') set defaultClosed(value: string | boolean) {
    if (value === 'true' || value) {
      this.click();
      this.toggledWhenDefaultOpened.emit();
    }
  }
  @Input('ariaAccordionDescription') set ariaAccordionDescription(
    value: string
  ) {
    this._ariaAccordionDescription = value
      ? `Toggle panel view for ${value}`
      : 'Toggle panel view';
  }
  get ariaAccordionDescription(): string {
    return this._ariaAccordionDescription;
  }

  @Input() shouldDisable = false;
  @Input() subAccordion = false;
  @Input() isDone = false;

  @Output() beforeToggle: EventEmitter<boolean> = new EventEmitter();
  @Output() afterToggle: EventEmitter<boolean> = new EventEmitter();

  @Output() toggledWhenOpened: EventEmitter<void> = new EventEmitter();
  @Output() toggledWhenClosed: EventEmitter<void> = new EventEmitter();
  @Output() toggledWhenDefaultOpened: EventEmitter<void> = new EventEmitter();

  @ViewChild('btnToggle', { static: true }) btnToggle;
  @ViewChild('accordionPanel', { static: true }) collapsablePanel: ElementRef;

  public click(): void {
    this.btnToggle.nativeElement.click();
  }

  public close(): void {
    if (this.isOpened()) {
      this.btnToggle.nativeElement.click();
    }
  }

  public open(): void {
    if (!this.isOpened()) {
      this.btnToggle.nativeElement.click();
    }
  }

  public isOpened(): boolean {
    return this.btnToggle.nativeElement.classList.contains('opened');
  }

  public toggle(event: any): void {
    if (this.canToggle) {
      event.preventDefault();

      let isOpened = this.isOpened();
      this.beforeToggle.emit(isOpened);

      const $sender = event.currentTarget;
      let parent = $sender.offsetParent;
      const iconClassList = $sender.getElementsByTagName('button')[0] ? $sender.getElementsByTagName('button')[0].classList : null;

      if (parent == null) {
        parent = $sender.parentElement.parentElement;
      }

      if (
        !$sender.classList.contains('opened') &&
        parent.classList.contains('disabled')
      ) {
        return;
      }
      if (iconClassList) {
        iconClassList.toggle('open-left');
        iconClassList.toggle('close-left');
        $sender.classList.toggle('opened');
        $sender.nextElementSibling.classList.toggle('hidden');
      }

      this.setTabIndex();

      isOpened = this.isOpened();
      this.afterToggle.emit(isOpened);
      if (isOpened) {
        this.toggledWhenOpened.emit();
      } else {
        this.toggledWhenClosed.emit();
      }
    } else {
      this.toggledWhenOpened.emit();
    }
  }

  private setTabIndex(): void {
    new TabIndexPipe().transform(this.isOpened(), this.collapsablePanel);
  }
}
